// Dependencies
// ============================================================================
import { $ } from '../common/utility/u-jquery-$';
import { UCookies } from '../common/utility/u-cookies';

// Global Variables
// ============================================================================
let modal = document.querySelector('dialog.v3-modal');
let modalId = null;
let cookieName = null;
let debugLog = true;
let isGdprRegion = window.on24_geoip.is_gdpr_region === 'true' || window.on24_geoip.is_gdpr_region === true;

// ƒs (Functions)
// ============================================================================

/**
 * Show the modal with accessibility enhancements and event handling
 *
 * @return {void}
 */
function showModal() {
	const html = document.querySelector("html");

	// If user is in a GDPR region and hasn't accepted cookies, don't show the modal
	if (isGdprRegion && !window.on24_onetrust_cookies_accepted) {
		console.log('🍪 Waiting for cookies consent before showing modal.');
		return;
	}

	if (modal) {
		const closeButton = modal.querySelector('.v3-modal__close');
		const modalContent = modal.querySelector('.v3-modal__main');
		const overlay = modal.querySelector('.v3-modal__overlay');

		html.classList.add('modal-open');
		modal.setAttribute('aria-hidden', 'false');
		modal.showModal();

		setTimeout(() => closeButton.focus(), 0);

		const handleCloseEvent = (event) => {
			if (
				event.type === 'click' ||
				(event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))
			) {
				event.preventDefault();
				hideModal();
			}
		};

		const stopPropagation = (event) => event.stopPropagation();

		closeButton.addEventListener('click', handleCloseEvent);
		closeButton.addEventListener('keydown', handleCloseEvent);
		modalContent.addEventListener('click', stopPropagation);
		overlay.addEventListener('click', handleCloseEvent);

		// Handle Escape key
		modal.addEventListener('close', () => {
			hideModal();
		});
	}
}

/**
 * Hide the modal, set accessibility attributes, and set a cookie if necessary
 *
 * @return {void}
 */
function hideModal() {
	const html = document.querySelector("html");

	if (modal) {
		html.classList.remove('modal-open');
		modal.setAttribute('aria-hidden', 'true');
		modal.close();

		if (modal.classList.contains('modal-view-once')) {
			document.cookie = `${cookieName}=true; path=/; max-age=${60 * 60 * 24 * 14}`;
		}

		// if (!modal.classList.contains('v3-modal--cta-trigger')) {
		// 	document.cookie = `modal_${modalId}_session=closed; path=/;`;
		// }
	}
}

/**
 * Set up event listeners for modal triggers, only if the relevant modal is present
 *
 * @return {void}
 */
function _initModalTriggers() {
	modal = document.querySelector('dialog.v3-modal');
	if (!modal) return;

	modalId = modal.getAttribute('id');
	cookieName = `modal_${modalId}_viewed`;

	const hasForceShow = modal.classList.contains('force-modal-show');
	const hasViewOnce = modal.classList.contains('modal-view-once');
	const hasSeenCookie = document.cookie.split('; ').some(row => row.startsWith(cookieName));

	if (hasViewOnce && hasSeenCookie && !hasForceShow) {
		console.log("Skipping modal as it's already been viewed");
		return;
	}

	// const sessionCookieName = `modal_${modalId}_session`;
	// if (document.cookie.split('; ').find(row => row.startsWith(sessionCookieName))) {
	// 	console.log("Skipping modal as it's already been closed in this session");
	// 	return;
	// }

	// if (window.on24_geoip.is_gdpr_region === 'true' && !window.on24_onetrust_cookies_accepted) {
	// 	console.log('🍪 Waiting for cookie consent, blocking modal triggers.');
	// 	return;
	// }
	let modalShown = false;
	if (document.querySelector('.v3-modal--cta-trigger')) {
		$('a[href^="#"]').each((i, anchor) => {
			anchor = $(anchor);
			const triggerModal = (event) => {
				if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					if (modal.classList.contains('v3-modal--cta-trigger')) {
						showModal();
						modalShown = true;
					}
				}
			};
			anchor.on('click keydown', triggerModal);
		});
	}
	
	let debounceTimeout;
	window.addEventListener('scroll', function () {
		clearTimeout(debounceTimeout);
		debounceTimeout = setTimeout(() => {
			if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight * 0.6 && !modalShown) {
				showModal();
				modalShown = true;
			}
		}, 200);
	});

	if (document.querySelector('.v3-modal--ToP-trigger')) {
		setTimeout(() => {
			if (!modalShown) {
				showModal();
				modalShown = true;
			}
		}, 20000);
	}

	if (document.querySelector('.v3-modal--exit-trigger')) {
		$(document).on('mousemove', function exitIntentTrigger(event) {
			if (event.clientY < 50 && !modalShown) {
				showModal();
				modalShown = true;
				$(document).off('mousemove', exitIntentTrigger);
			}
		});
	}
}


/**
 * Check for the cookie OptanonAlertBoxClosed
 * (To see if user has interacted with Cookie Consent Box)
 * 
 * @return boolean
 */
function checkFunctionalCookies() {
	if ( UCookies.getCookie( 'OptanonAlertBoxClosed' ) || UCookies.getCookie( 'OptanonConsent' ) ) {
		let otCookieFull = UCookies.getCookie( 'OptanonConsent' );

		// Decode (converts eg. "C0001%3A1%2CC0003%3A1%2CC0002%3A1%2CC0004%3A1" to "C0001:1,C0003:1,C0002:1,C0004:1")
		otCookieFull = decodeURIComponent( otCookieFull );
		
		// Break cookie down into the parts we want
		// Example:
		//   isGpcEnabled=0&datestamp=Mon+Oct+16+2023+19:24:45+GMT+0100+(British+Summer+Time)&version=202305.1.0&browserGpcFlag=0&isIABGlobal=false&hosts=&consentId=4b3d9c39-526f-4eea-add0-4b9667719ad5&interactionCount=1&landingPath=NotLandingPage&groups=C0001:1,C0003:1,C0002:1,C0004:1
		// We need this part:
		//   &groups=C0001:1,C0003:1,C0002:1,C0004:1
		const otCookieArr = otCookieFull.split( '&' );

		// Get the group settings
		let settingsStr              = '';
		settingsStr                  = otCookieArr.filter( ( val ) => val.startsWith( 'groups=' ) )[0];
		settingsStr                  = settingsStr.replace( 'groups=', '' );
		const settingsArr            = settingsStr.split( ',' ); // eg: ['C0001:1', 'C0003:1', 'C0002:1', 'C0004:1']

		// Split the settings and grab just the Functional Cookie value
		const functionalCookies      = settingsArr.filter( (val ) => val.startsWith( "C0003:" ) );
		const functionalCookiesValue = functionalCookies.length > 0 ? functionalCookies[0].split(":")[1] : null;

		if (functionalCookiesValue === "1") {

			if( debugLog ) {
				console.log("✅ Functional Cookies: ACCEPTED, Enabling Modal Triggers");
			}

			_initModalTriggers();

		} else if (functionalCookiesValue === "0") {

			if( debugLog ) {
				console.log("🚫 Functional Cookies: REJECTED, Blocking Modal Triggers");
			}

			return;
		} else {

			if( debugLog ) {
				console.log("⚠️ Functional Cookies: not found");
			}

			return;
		}
	}
}

// #1124 - Need to make sure that if the user is in a GDPR region, they allow functional cookies for Modals to Work.
document.addEventListener("DOMContentLoaded", function () {
	
	if ( modal ) {

		if( debugLog ) {
			console.log( 'NEW Modal Location: ', window.on24_geoip );
			console.log( 'NEW Modal Location, GDPR: ', window.on24_geoip.is_gdpr_region );
		}

		if ( isGdprRegion ) {

			if ( debugLog )
			{
				console.log('🌍 User is in a GDPR region. Waiting for cookie consent.');
			}

			// Check to see if Cookies have already been set prior to page load
			if ( UCookies.getCookie( 'OptanonAlertBoxClosed' ) ) {
				
				if ( debugLog )
				{
					console.log("⏳ Cookies we're already set on page load, checking to see if they're enabled...")
				}
				checkFunctionalCookies();
			} else {
				$( window ).on( 'on24_onetrust_cookies_accepted', () => {

					if ( debugLog )
					{
						console.log('✅ Cookie Options Updated');
					}
	
					checkFunctionalCookies();
				});
			}

		} else {
			if ( debugLog )
			{
				console.log("🌍 User is NOT in a GDPR region. Proceeding without restrictions.");
			}
			_initModalTriggers();
		}
	}
});